module.exports = __webpack_public_path__ + "static/img/mission-control.8ade099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mission-control.jpg
// module id = 70Yd
// module chunks = 0